import { useEffect, useMemo, useState } from 'react';
import GlobalTableGenerator from '../../../components/GlobalTableGenerator';
import { tableHeaderFn } from './utils/tableHeader';
import Stack from '@mui/material/Stack';
import { projects } from './utils/projects';
import CustomeTabSwitcher from '../CustomTabSwitcher/CustomeTabSwitcher';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import StudentTable from '../studentTable/StudentTable';
import { useDispatch } from 'react-redux';
import { getPlacementTrackerSessions } from '../../../redux/features/generalSlice';
import { useSelector } from 'react-redux';

export default function SessionTable({ row }) {
  const [studet, setStudent] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const dispatch = useDispatch();

  const placementTrackerSessions = useSelector((state) => state.general.placementTrackerSession.data);
  const placementTrackerSessionsLoading = useSelector((state) => state.general.placementTrackerSession.loading);

  useEffect(() => {
    dispatch(getPlacementTrackerSessions(row?.trainer_id));
  }, [row, dispatch]);

  const columns = useMemo(() => tableHeaderFn({ setStudent }), []);

  return (
    <Stack gap={2} minWidth={600}>
      <CustomeTabSwitcher tabsArray={projects} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
      <GlobalTableGenerator
        columns={columns}
        rows={placementTrackerSessions?.filter((v) => v?.project_id === activeIndex + 1)}
        loading={placementTrackerSessionsLoading}
      />
      <GlobalDialog
        title={'Student Details'}
        open={Boolean(studet)}
        setOpen={setStudent}
        content={<StudentTable row={studet ? studet : {}} trainerId={row?.trainer_id} />}
        closeButton
        maxWidth={'lg'}
      />
    </Stack>
  );
}
